import { render, staticRenderFns } from "./app-logo.vue?vue&type=template&id=a5f0f6c4&"
import script from "./app-logo.vue?vue&type=script&lang=js&"
export * from "./app-logo.vue?vue&type=script&lang=js&"
import style0 from "./app-logo.vue?vue&type=style&index=0&id=a5f0f6c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports